import { entityClient } from '@/shared/libs/base44'

export const Subsidiary = entityClient<any>('Subsidiary')
export const Department = entityClient<any>('Department')
export const Project = entityClient<any>('Project')
export const User = Object.assign(entityClient<any>('User'), {
  async me(): Promise<any> {
    throw new Error('User.me not available with API key auth')
  }
})
export const BudgetCategory = entityClient<any>('BudgetCategory')
export const Expense = entityClient<any>('Expense')
export const Document = entityClient<any>('Document')

export default { Subsidiary, Department, Project, User, BudgetCategory, Expense, Document }

